/**
 * Copy and defaults for the Showcare (ShowLead) toolkit fields, shared by the
 * per-conference form and the reusable-config create/edit forms. The license
 * key is the "License Key" on Showcare's ShowLead order confirmation email;
 * Showcare must activate it for the API before lookups work. It is stored as a
 * secret. The device name the API needs is fixed on the server.
 */
export { FPLEADS_HTTPS_RULE as SHOWCARE_HTTPS_RULE } from './fpleadsCopy';

/** Same rule as the server: the license key rides in a query string, so no spaces or line breaks anywhere. */
export const SHOWCARE_LICENSE_KEY_RULE = {
  validator: (_: unknown, v?: string) =>
    !v || /^\S+$/.test(v) ? Promise.resolve() : Promise.reject(new Error('License key must not contain spaces or line breaks')),
};

/** Same rule as the server: the client appends /get-token?... to the base URL, so no query, fragment or credentials. */
export const SHOWCARE_BASE_URL_SHAPE_RULE = {
  validator: (_: unknown, v?: string) => {
    if (!v) return Promise.resolve();
    let ok = !/[?#\s]/.test(v);
    try {
      const u = new URL(v);
      ok = ok && u.username === '' && u.password === '';
    } catch { /* the url rule reports an unparseable value */ }
    return ok ? Promise.resolve() : Promise.reject(new Error('Base URL must not include a query string, fragment or credentials'));
  },
};

export const SHOWCARE_DEFAULT_BASE_URL = 'https://www.showlead.com/api/v1';

export const SHOWCARE_BASE_URL_EXTRA =
  "Showcare's Event API address. The default is Showcare's production API.";

export const SHOWCARE_LICENSE_KEY_EXTRA =
  "The License Key from Showcare's ShowLead order confirmation email. Showcare must activate it for the API. Never paste it into Slack or a shared doc.";
